// Extracted from `src/features/patientContext/const.ts` (slice 1 of
// the `patientContext` carve) — history: git log --follow src/features/patientContext/const.ts
//
// Only these two symbols moved. `PatientContextFormSchema` and
// `PatientContextFormValues` stay at the old path deliberately: their only
// consumer has no importers repo-wide, and moving dead code into a package is
// not a carve. `GENDER_OPTIONS` already lives on this door beside them.
//
// Both are the patient-context field VOCABULARY — which extracted fields exist
// and how each is rendered — so they read as contract, not as panel state.

/** Context fields whose value is edited in a textarea rather than an input. */
export const MULTILINE_FIELDS = [
  'allergies',
  'current_medications',
  'past_medical_history',
];

export const PatientContextItemLabelMap: Record<string, string> = {
  first_name: 'First Name',
  last_name: 'Last Name',
  gender: 'Gender',
  birth_date: 'Birth Date',
  phone: 'Phone',
  email: 'Email',
  allergies: 'Allergies',
  current_medications: 'Current Medication',
  past_medical_history: 'Past Medical History',
};
